import { viewTypes } from '../../constants/shit-view-types'

export default {
  namespaced: true,
  state: {
    textSize: 'text-base',
    view: viewTypes.VIEW_DEFAULT
  },
  mutations: {
    setTextSize (state, value) {
      state.textSize = value
    },
    setView (state, value) {
      state.view = value
    }
  }
}
